<app-loader-spinner [isLoading]="isLoading()"></app-loader-spinner>
<p-dialog
    [(visible)]="visible"
    (onHide)="onClose()"
    [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '45vw' }"
    [header]="'Actualización de registro Unificación a Renovación - #' + selectedProyecto?.numeroExpediente"
    [draggable]="false"
    [closable]="true"
>
    <ng-template pTemplate="content">
        <p-messages severity="warn" *ngIf="this.tramiteSolicitud?.nombreTramite && this.tramiteSolicitud.nombreTramite!.toUpperCase()!.includes('PRIMERA VEZ')">
            <ng-template pTemplate>
                <div class="ml-2  text-xl">Sí el trámite es primera vez, debe haber una migración para el ámbito de registro para realizar el cambio a Unificación ó Renovación.
                </div>
            </ng-template>
        </p-messages>
        <div class="grid">
            <!-- Columna izquierda con scroll solo en pantallas medianas y grandes -->
            <div class="col-12 md:col-5">
                <label class="text-900 font-semibold mb-4">Trámite a cambiar
                </label>
                <div class="w-full">
                    <ng-container *ngIf="tramiteSolicitud">
                        <input class="w-full" pInputText type="text" [disabled]="true" [placeholder]="tramiteSolicitud.nombreTramite!"
                        [pTooltip]="tramiteSolicitud.nombreTramite!">
                    </ng-container>

                </div>
            </div>
            <div class="col-12 md:col-7">
                <div class="flex flex-column">
                    <label class="text-900 font-semibold">Trámite nuevo</label>
                    <ng-container>
                        <p-dropdown
                        appendTo="body"
                        styleClass="w-full"
                        [options]="opcionesTramitesValidas()"
                        optionDisabled="isOpcionDeshabilitada"
                        [(ngModel)]="selectedTramiteCambio"
                        optionLabel="nombreTramite"
                        placeholder="Seleccione un trámite"

                        ></p-dropdown>
                    </ng-container>

                </div>
            </div>
        </div>

    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex justify-content-between align-items-center">
            <!-- Proceso para registrar antes de que haya registro de migracion de profesionales -->
            <div *ngIf="this.tramiteSolicitud?.nombreTramite && this.tramiteSolicitud.nombreTramite!.toUpperCase()!.includes('PRIMERA VEZ')"
                class="flex flex-column">
                <p-button
                    *ngIf="this.ls.isRolJefeRegistro() || this.ls.isRolTecnicoRegistro()"
                    label="Registrar migración" icon="pi pi-id-card text-2xl"
                    styleClass="p-button-info p-button-rounded ml-2"
                    pTooltip="Con esta opción puedes registrar la migración de un profesional que no se encuentre en la base de datos migrada."
                    (click)="this.rpService._openDlg.set(true)"
                    [disabled]="tieneMigracion()"/>
            </div>
            <div class="justify-content-end align-items-end">
                <ng-container>
                    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="onClose()"></button>
                </ng-container>
                <ng-container>
                    <button pButton pRipple type="submit" icon="pi pi-check" class="p-button-text" label="Cambiar Registro" (click)="procesarCambioRegistro()"
                    [pTooltip]="'Cambiar el trámite de la solicitud seleccionada'"
                    [disabled]="!tieneMigracion() && tramiteSolicitud.nombreTramite.toUpperCase().includes('PRIMERA VEZ')"></button>
                </ng-container>
            </div>
        </div>
    </ng-template>
</p-dialog>
<ng-container *ngIf="this.ls.isRolJefeRegistro() || this.ls.isRolTecnicoRegistro()">
    <app-rp-create-dlg></app-rp-create-dlg>
</ng-container>
